import { Link } from 'react-router-dom'
import { Button } from '@/ui/button'

/** Bereichs-404 der Admin-Konsole (BMC/shadcn) — verweist zurück auf /admin. */
export function AdminNotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center text-foreground">
      <p className="text-sm font-semibold uppercase tracking-widest text-primary">404</p>
      <h1 className="text-2xl font-semibold tracking-tight">Seite nicht gefunden</h1>
      <p className="max-w-md text-muted-foreground">Diese Konsolen-Seite existiert nicht.</p>
      <Button asChild variant="outline">
        <Link to="/admin">Zur Konsole</Link>
      </Button>
    </div>
  )
}
